import { Skeleton } from "@vega-core/components/shadcn/skeleton";

const CoInvestmentRowSkeleton = () => (
  <div className="grid grid-cols-1 xs:grid-cols-[1fr_1.1fr] gap-4 justify-between py-6 md:p-6 border-b border-border/primary first:border-t first:border-t-border/primary">
    <div className="flex flex-col col-span-1 sm:flex-row gap-4 px-2 md:px-0">
      <Skeleton className="w-16 h-16 rounded-lg" />
      <div className="flex flex-col gap-y-2 flex-1">
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-5 w-24" />
      </div>
    </div>
    <div className="flex items-center px-2 sm:px-0 sm:justify-end">
      <div className="lg:text-right">
        <Skeleton className="h-4 w-20 mb-1" />
        <Skeleton className="h-5 w-16" />
      </div>
    </div>
  </div>
);

export const CoInvestmentsListSkeleton = () => (
  <div className="overflow-hidden">
    {Array.from({ length: 3 }, (_, index) => (
      <CoInvestmentRowSkeleton key={`co-investment-skeleton-${index}`} />
    ))}
  </div>
);
